<script lang="ts" setup>
import { computed } from "vue";
import { RouterLink, useRouter } from "vue-router";

import { useSearchRoute } from "@/common/composables/use-search-route";
import type { GyldendalShortViewItem } from "@/types/article-formats/gyldendal";

const props = defineProps<{
  item: GyldendalShortViewItem;
}>();

const router = useRouter();

const searchRoute = computed(() =>
  useSearchRoute(router).getSearchRoute(
    props.item.translationSearchStr,
    props.item.methodId.slice(-4)
  )
);
</script>

<template>
  <span v-if="item.translationSearchStr && item.methodId">
    <RouterLink :to="searchRoute" class="article-content__link">{{
      item.translation?.translation ?? item.translationSearchStr
    }}</RouterLink>
  </span>
  <span v-else-if="item.translation">{{ item.translation.translation }}</span>
  <span v-else-if="item.targetLanguageDefinition">{{ item.targetLanguageDefinition }}</span>

  <span v-if="item.definition"
    ><span>&nbsp;</span><span class="font-italic">{{ item.definition }}</span></span
  >
</template>
